var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2633c"
    },
    d: "M438.747,54.99c0.563,0.423,0.905,1.077,0.905,1.782v377.315c0,12.295-9.966,22.261-22.261,22.261 h-11.13h-256h-11.13h-33.391h-11.13c-6.147,0-11.13-4.983-11.13-11.13V55.652V23.976C83.478,10.734,93.444,0,105.739,0h11.13H128 h289.391h11.13h4.96c2.008,0,2.982,2.442,1.532,3.83c-6.718,6.43-10.803,14.831-10.803,23.996 C424.21,38.583,429.838,48.289,438.747,54.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6D53"
    },
    d: "M183.313,411.826V512l-33.22-19.915L116.87,512V411.826H183.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e0000"
    },
    d: "M428.522,55.652v378.435c0,12.295-9.966,22.261-22.261,22.261h-11.13h-256H128H94.609h-11.13 c-6.147,0-11.13-4.983-11.13-11.13V55.652V33.391h341.255C415.239,42.247,420.696,50.08,428.522,55.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca4316"
    },
    d: "M105.739,0h11.13v456.348H94.609h-11.13c-6.147,0-11.13-4.983-11.13-11.13V55.652V23.976 C72.348,10.734,82.314,0,94.609,0H105.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A09982"
    },
    d: "M116.87,55.652c-12.295,0-22.261-9.966-22.261-22.261v-9.415C94.609,10.734,104.575,0,116.87,0 h305.481c2.008,0,2.982,2.442,1.532,3.83c-6.718,6.43-10.803,14.831-10.803,23.996l0,0c0,11.116,6.01,21.111,15.442,27.826H116.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1B69A"
    },
    d: "M128,55.652c-12.295,0-22.261-9.966-22.261-22.261v-9.415C105.739,10.734,115.705,0,128,0h294.351 c2.008,0,2.982,2.442,1.532,3.83c-6.718,6.43-10.803,14.831-10.803,23.996l0,0c0,11.116,6.01,21.111,15.442,27.826H128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACA38B"
    },
    d: "M413.079,27.826c0,1.892,0.187,3.749,0.523,5.565H166.957c-3.073,0-5.565-2.492-5.565-5.565 s2.492-5.565,5.565-5.565h246.642C413.263,24.077,413.079,25.934,413.079,27.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEB896"
    },
    d: "M363.403,194.223c0,17.568-14.291,31.861-31.859,31.861h-82.553c-5.293,0-9.6,4.306-9.6,9.6v20.729 c0,6.147-4.983,11.13-11.13,11.13c-6.147,0-11.13-4.983-11.13-11.13v-20.729c0-17.568,14.293-31.861,31.861-31.861h82.553 c5.293,0,9.598-4.306,9.598-9.6c0-5.293-4.305-9.6-9.598-9.6H185.71c-17.567,0-31.86-14.293-31.86-31.86s14.291-31.86,31.86-31.86 h90.543c5.293,0,9.6-4.306,9.6-9.599c0-6.147,4.983-11.13,11.13-11.13c6.147,0,11.13,4.983,11.13,11.13 c0,17.567-14.293,31.86-31.861,31.86H185.71c-5.293,0-9.599,4.306-9.599,9.599s4.306,9.599,9.599,9.599h145.834 C349.111,162.362,363.403,176.654,363.403,194.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98642E"
    },
    d: "M384,390.368c0,6.147-4.983,11.13-11.13,11.13h-24.881c-0.022,0-0.042,0.003-0.065,0.003 c-0.022,0-0.042-0.003-0.065-0.003H190.737c-0.022,0-0.042,0.003-0.065,0.003s-0.042-0.003-0.065-0.003h-24.88 c-6.147,0-11.13-4.983-11.13-11.13c0-6.147,4.983-11.13,11.13-11.13h13.814v-6.563c0-45.72,34.371-83.539,78.625-89.041v-12.218 c0-6.147,4.983-11.13,11.13-11.13s11.13,4.983,11.13,11.13v12.218c44.256,5.503,78.627,43.321,78.627,89.04v6.563h13.815 C379.017,379.237,384,384.22,384,390.368z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d54848"
    },
    d: "M338.242,315.28c-16.477,19.759-41.265,32.359-68.945,32.359c-27.679,0-52.466-12.601-68.943-32.359 c16.477-19.759,41.264-32.359,68.943-32.359C296.977,282.92,321.763,295.521,338.242,315.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d54848"
    },
    d: "M384,390.368c0,6.147-4.983,11.13-11.13,11.13H165.728c-6.147,0-11.13-4.983-11.13-11.13 c0-6.147,4.983-11.13,11.13-11.13H372.87C379.017,379.237,384,384.22,384,390.368z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBook);
export default __webpack_public_path__ + "static/media/menuBook.a061dff7874fc26957d61ec7f7f956c5.svg";
export { ForwardRef as ReactComponent };